











































































import Vue from "vue";
import SelectBox from "@/components/util/SelectBox.vue";
import ReturnTop from "@/parts/util/ReturnTop.vue";

import { sortedByDateDesc } from "@/utils/momentUtils";

import { getUserReviews } from "@/api/ReviewCorporate";
import { ReviewResponse } from "@/api/dto/ReviewCorporate";
import { UserProfile } from '@/api/dto/UserProfile';

/**
 * 取引ステータス
 */
export type DealStatus =
  | "1" // 下書き、期限切れ
  | "2" // 査定中
  | "3" // 承諾待ち
  | "4" // レビュー中
  | "5"; // 完了

/** 取引ステータス：下書き、期限切れ */
export const Draft = "1" as DealStatus;
/** 取引ステータス：査定中 */
export const UnderReview = "2" as DealStatus;
/** 取引ステータス：承諾待ち */
export const AgreementPending = "3" as DealStatus;
/** 取引ステータス：レビュー中 */
export const InReview = "4" as DealStatus;
/** 取引ステータス：完了 */
export const Completed = "5" as DealStatus;

export default Vue.extend({
  name: "CorpRequest",
  components: {
    SelectBox,
    ReturnTop,
  },
  data() {
    return {
      dealStatus: {
        Draft: "1",
        UnderReview: "2",
        AgreementPending: "3",
        InReview: "4",
        Completed: "5",
      },
      setKeyword: "",
      status: [
        { name: "All", value: "0", text: "すべて", to: "/mypage", active: true },
        { name: "Draft", value: "1", text: "下書き", to: "/mypage/settings", active: false },
        { name: "UnderReview", value: "2", text: "査定中", to: "/mypage", active: false },
        { name: "agreementPending", value: "3", text: "承諾待ち", to: "/mypage/deals", active: false },
        { name: "InReview", value: "4", text: "レビュー中", to: "/mypage/payouts", active: false },
        { name: "Completed", value: "5", text: "完了", to: "/mypage/settings", active: false },
      ],
      reviewList: [] as ReviewResponse[],
      active: "0",
    };
  },
  async beforeRouteEnter(to, from, next) {
    try {
      // 表示用情報取得
      const reviewList = sortedByDateDesc(await getUserReviews(), (it) => it.updateDate);
      next((vm) => {
        vm.$data.reviewList = reviewList;
      });
    } catch (e) {
      console.log(e);
      next({ name: "Top" });
    }
  },
  computed: {
    filteredReview(): ReviewResponse[] {
      if (this.active == "0") {
        if (this.setKeyword) {
          return this.reviewList.filter((value) => value.title?.includes(this.setKeyword));
        } else {
          return this.reviewList;
        }
      } else {
        let filterdReviewList = this.reviewList.filter((value) => value.dealStatus?.includes(this.active));
        if (this.setKeyword) {
          return filterdReviewList.filter((value) => value.title?.includes(this.setKeyword));
        } else {
          return filterdReviewList;
        }
      }
    },
  },
  methods: {
    /** ステータス文言を返却 */
    statusLabel(reviewData: any): string {
      switch (reviewData.dealStatus) {
        case Draft:
          return "下書き";
        case UnderReview:
          return "査定中";
        case AgreementPending:
          return "承諾待ち";
        case InReview:
          return "レビュー中";
        case Completed:
          return "完了";
        default:
          return "";
      }
    },
    detailLink(dealId: string) {
      return "/corporate/review/" + dealId;
    },
    selectMenu(i: number) {
      this.status.map((v) => (v.active = false));
      this.status[i].active = !this.status[i].active;
      this.active = String(i);
    },
    /** 経過時間の割り出し処理 */
    getUpdated(reviewData: any): string {
      let posted = new Date(reviewData.updateDate);
      // 差分 = 現在の日時 - 投稿日時
      let diff = new Date().getTime() - posted.getTime();
      // 経過時間をDateに変換
      let progress = new Date(diff);
      let text = "";

      if (progress.getUTCFullYear() - 1970) {
        text = progress.getUTCFullYear() - 1970 + "年前";
      } else if (progress.getUTCMonth()) {
        text = progress.getUTCMonth() + "ヶ月前";
      } else if (progress.getUTCDate() - 1) {
        text = progress.getUTCDate() - 1 + "日前";
      } else if (progress.getUTCHours()) {
        text = progress.getUTCHours() + "時間前";
      } else if (progress.getUTCMinutes()) {
        text = progress.getUTCMinutes() + "分前";
      } else {
        text = "たった今";
      }
      return text;
    },
    toDraft() {
      const user = this.$store.getters.userProfile as UserProfile;
      if (user.corporationsData.paymentType == '1') {
        if (!user.corporationsData.registeredCreditCard) {
          this.$emit('errorToast', 'クレジットカードが登録されていないため、依頼を作成できません。');
          return;
        }
      }
      this.$router.push({ name: "CorpReviewDraft" }, () => {});
    }
  },
  filters: {
    amountLocaleString: function (amount: number) {
      if (amount == null) {
        return "";
      }
      return "¥" + amount.toLocaleString();
    },
  },
});
